import * as React from "react"

import useAltShortcut from "shared/hooks/useAltShortcut"

import type { SidebarItem } from "../types"

import { Icon, Label, StyledLink } from "./Styles"

const Link = ({ icon, text, shortcutLetter, isActive, action }: SidebarItem): JSX.Element => {
  const label = useAltShortcut(text, shortcutLetter, action)

  return (
    <StyledLink onClick={action} isActive={isActive}>
      <Icon>{icon}</Icon>
      <Label>{label}</Label>
    </StyledLink>
  )
}

export default Link
